import { createUploadLink } from "apollo-upload-client";
import { ApolloClient } from "apollo-client";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";

const isProduction = process.env.NODE_ENV === "production";

const URL = isProduction
  ? "https://api.desigualdadessalud.org:18443/graphql"
  : "http://localhost:4000";

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const uploadLink = createUploadLink({
  uri: URL,
});

const client = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

export default client;



// WEBPACK FOOTER //
// ./src/lib/apollo.js